<script setup>
/*
ClockFormResume.vue
Part of the form wizard to choose to resume the clock now, pick a time, or cancel.
*/
import { ref } from "vue";

// Define emitted events
const emits = defineEmits(["cancel", "now", "specify"]);

// Define props with task and clock data
const props = defineProps({
    request: {
        type: Object,
        default: null,
    },
    client: {
        type: Object,
        default: null
    },
    task: {
        type: Object,
        default: null
    },
    clock: {
        type: Object,
        default: null
    }
});
</script>

<template>
    <div class="row">
        <div class="col">
            <div class="row">
                <div class="col mx-auto">
                    <strong>Client:</strong> {{ props.client?.Company }}<br />
                    <strong>Job:</strong> {{ props.request?.TaskDetail || props.request?.RequestDetailedDescription }}
                    <span v-if="props.task?.WorkAssignment">
                        <br />
                        <strong>Task:</strong> {{ props.task.WorkAssignment }}
                    </span>
                </div>
            </div>

            <hr />

            <div class="row mt-2">

                <div class="col-4 my-2">
                    <button class="btn btn-secondary form-control h-100" @click="$emit('cancel')">
                        <span>Cancel</span>
                    </button>
                </div>

                <div class="col-4 my-2">
                    <button class="btn btn-primary form-control h-100" @click="$emit('specify')">
                        Specify Time
                    </button>
                </div>

                <div class="col-4 my-2">
                    <button class="btn btn-success form-control h-100" @click="$emit('now')">
                        Resume Now
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>
